/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The AnswerDto model module.
 * @module model/AnswerDto
 * @version v0
 */
class AnswerDto {
    /**
     * Constructs a new <code>AnswerDto</code>.
     * @alias module:model/AnswerDto
     * @param content {String} 
     * @param isCorrect {Boolean} 
     * @param questionId {Number} 
     */
    constructor(content, isCorrect, questionId) { 
        
        AnswerDto.initialize(this, content, isCorrect, questionId);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, content, isCorrect, questionId) { 
        obj['content'] = content;
        obj['is_correct'] = isCorrect;
        obj['question_id'] = questionId;
    }

    /**
     * Constructs a <code>AnswerDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AnswerDto} obj Optional instance to populate.
     * @return {module:model/AnswerDto} The populated <code>AnswerDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AnswerDto();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('content')) {
                obj['content'] = ApiClient.convertToType(data['content'], 'String');
            }
            if (data.hasOwnProperty('is_correct')) {
                obj['is_correct'] = ApiClient.convertToType(data['is_correct'], 'Boolean');
            }
            if (data.hasOwnProperty('question_id')) {
                obj['question_id'] = ApiClient.convertToType(data['question_id'], 'Number');
            }
            if (data.hasOwnProperty('created_at')) {
                obj['created_at'] = ApiClient.convertToType(data['created_at'], 'Date');
            }
            if (data.hasOwnProperty('updated_at')) {
                obj['updated_at'] = ApiClient.convertToType(data['updated_at'], 'Date');
            }
            if (data.hasOwnProperty('created_by')) {
                obj['created_by'] = ApiClient.convertToType(data['created_by'], 'String');
            }
            if (data.hasOwnProperty('updated_by')) {
                obj['updated_by'] = ApiClient.convertToType(data['updated_by'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AnswerDto</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AnswerDto</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of AnswerDto.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['content'] && !(typeof data['content'] === 'string' || data['content'] instanceof String)) {
            throw new Error("Expected the field `content` to be a primitive type in the JSON string but got " + data['content']);
        }
        // ensure the json data is a string
        if (data['created_by'] && !(typeof data['created_by'] === 'string' || data['created_by'] instanceof String)) {
            throw new Error("Expected the field `created_by` to be a primitive type in the JSON string but got " + data['created_by']);
        }
        // ensure the json data is a string
        if (data['updated_by'] && !(typeof data['updated_by'] === 'string' || data['updated_by'] instanceof String)) {
            throw new Error("Expected the field `updated_by` to be a primitive type in the JSON string but got " + data['updated_by']);
        }

        return true;
    }


}

AnswerDto.RequiredProperties = ["content", "is_correct", "question_id"];

/**
 * @member {Number} id
 */
AnswerDto.prototype['id'] = undefined;

/**
 * @member {String} content
 */
AnswerDto.prototype['content'] = undefined;

/**
 * @member {Boolean} is_correct
 */
AnswerDto.prototype['is_correct'] = undefined;

/**
 * @member {Number} question_id
 */
AnswerDto.prototype['question_id'] = undefined;

/**
 * @member {Date} created_at
 */
AnswerDto.prototype['created_at'] = undefined;

/**
 * @member {Date} updated_at
 */
AnswerDto.prototype['updated_at'] = undefined;

/**
 * @member {String} created_by
 */
AnswerDto.prototype['created_by'] = undefined;

/**
 * @member {String} updated_by
 */
AnswerDto.prototype['updated_by'] = undefined;






export default AnswerDto;

